import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { NewsLetterPopupComponent } from '../../shared/popups/newsletter-popup/newsletter-popup.component';
import { PublicSubscribersService } from '../../shared/services/public-subscriber.service';

@Component({
  selector: 'el-core-unsubscribe-page-component',
  templateUrl: './unsubscribe-page.component.html',
  styleUrls: ['./unsubscribe-page.component.scss'],
})
export class UnsubscribePageComponent implements OnInit {
  constructor(
    private publicSubscriberService: PublicSubscribersService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private matDialog: MatDialog
  ) {}

  success: boolean;
  title: string;
  subtitle: string;
  email: string;
  ngOnInit() {
    this.title = this.translate.instant('subscriber.unsubscribe-title');
    this.subtitle = this.translate.instant('subscriber.unsubscribe-subtitle');

    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      this.publicSubscriberService.deleteSubscriber(id).subscribe({
        next: () => {
          this.success = true;
        },
        error: () => {
          this.success = false;
        },
      });
    });

    this.route.queryParams.subscribe((params) => {
      this.email = params['email'];
      console.log(this.email);
    });
  }

  onClick() {
    this.matDialog.open(NewsLetterPopupComponent, {
      maxWidth: '800px',
      width: '100%',
      maxHeight: '100vh',
    });
  }
}
